import { ArrowRightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import React from 'react';

interface Step3BudgetProps {
  selectedBudget: string;
  onSelect: (budget: string) => void;
  onFinish: () => void;
  loading?: boolean;
}

const BUDGET_TIERS = [
  'Under ₹10,000',
  '₹10,000 – ₹50,000',
  '₹50,000 – ₹1 Lakh',
  '₹1 Lakh – ₹5 Lakh',
  '₹5 Lakh+',
  'Not sure yet',
];

const Step3Budget: React.FC<Step3BudgetProps> = ({
  selectedBudget,
  onSelect,
  onFinish,
  loading = false,
}) => {
  return (
    <div className='flex flex-col items-center text-center'>
      <h1 className='text-2xl md:text-3xl font-bold text-white tracking-tight mb-2'>
        What's your annual learning budget for your team?
      </h1>
      <p className='text-sm text-grayZl-400 mb-8 max-w-md'>
        Help us recommend the right credit tier for your team.
      </p>

      {/* Chips */}
      <div className='flex flex-wrap justify-center gap-3 max-w-xl mb-10'>
        {BUDGET_TIERS.map((tier) => {
          const isSelected = selectedBudget === tier;
          return (
            <button
              key={tier}
              type='button'
              onClick={() => onSelect(tier)}
              className={clsx(
                'group flex items-center gap-2.5 px-4 py-2.5 rounded-xl border text-sm font-medium transition-all duration-150 cursor-pointer active:scale-95',
                isSelected
                  ? 'bg-[#151515] border-[#FF5612] text-[#FF5612] shadow-[0_0_15px_rgba(255,86,18,0.2)]'
                  : 'bg-[#121212] border-[#262626] text-grayZl-200 hover:border-neutral-600 hover:bg-[#181818]',
              )}
            >
              {/* Radio indicator */}
              <div
                className={clsx(
                  'w-4 h-4 rounded-full border flex items-center justify-center transition-colors',
                  isSelected
                    ? 'border-[#FF5612]'
                    : 'border-grayZl-500 group-hover:border-grayZl-400',
                )}
              >
                {isSelected && (
                  <div className='w-2 h-2 rounded-full bg-[#FF5612]' />
                )}
              </div>
              <span className={isSelected ? 'text-[#FF5612] font-semibold' : 'text-white'}>
                {tier}
              </span>
            </button>
          );
        })}
      </div>

      <p className='text-xs text-grayZl-400 mb-6'>
        We'll recommend an option based on your team size and learning goals.
      </p>

      <button
        type='button'
        onClick={onFinish}
        disabled={!selectedBudget || loading}
        className='px-8 h-12 bg-[#FF5612] hover:bg-[#E54D10] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-xl text-sm transition-all duration-150 flex items-center justify-center gap-2 shadow-lg cursor-pointer active:scale-98'
      >
        <span>{loading ? 'Saving Setup...' : 'Continue to Dashboard'}</span>
        <ArrowRightOutlined className='text-xs' />
      </button>
    </div>
  );
};

export default Step3Budget;
